export const DEFAULT_BATCH_DELAY = 60000
export const TAL = 'TAL'
export const PORTS_LIST = ['RIG', 'HEL', 'TAL', 'TUR', 'STO', 'SAS', 'PAL']
export const SHIPS_LIST = [
  'MEGASTAR',
  'STAR',
  'REGAL STAR',
  'S.GALAXY',
  'T.EUROPA',
  'SEAWIND',
  'SERENADE',
  'SYMPHONY',
  'QUEEN',
  'VICTORIA',
  'S.PRINCESS',
  'ISABELLE',
  'ROMANTIKA',
]
